/**
 * <s-tracking-form data-url="https://t.17track.net/fr#nums=">
 * Wraps a tracking <form>. On submit, opens data-url with the trimmed,
 * URL-encoded tracking number appended, in a new tab. Without JavaScript the
 * form falls back to its native GET action.
 */
class STrackingForm extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac?.abort();
    this.#ac = new AbortController();

    const form = this.querySelector('form');
    const input = this.querySelector('[data-tracking-input]');
    if (!form || !input) return;

    form.addEventListener('submit', (event) => {
      const base = this.dataset.url;
      const number = input.value.trim();
      if (!base || !number) return;

      event.preventDefault();
      window.open(base + encodeURIComponent(number), '_blank', 'noopener');
    }, { signal: this.#ac.signal });
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }
}

if (!customElements.get('s-tracking-form')) customElements.define('s-tracking-form', STrackingForm);
